import React from 'react'
import { useSpring, animated } from 'react-spring'

export const Header: React.FC = () => {
    const props = useSpring({
        delay: 500,
        from: { y: -50, opacity: 0 },
        config: { duration: 500 },
        loop: {
            y: 0,
            opacity: 1
        },
    })

    return (
        <animated.div style={props}>
            <div className='bp-my-12'>
                <pichincha-typography align='left' variant="h5" color='Grayscale' weight_color='500'>
                    Cuotas de acuerdo a tu necesidad
                </pichincha-typography>
            </div>
        </animated.div>
    )
}

